import { getPerspectiveId } from "@app/lib/perspective";
import ReviewPage, { PAGE_SIZE, reviewQuery } from "@app/pages/review/review-page";
import type { reviewPage_Query } from "@app/queries/reviewPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/review")({
  loader: () =>
    loadQuery<reviewPage_Query>(
      environment,
      reviewQuery,
      { perspectiveId: getPerspectiveId() ?? undefined, limit: PAGE_SIZE, offset: 0 },
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Categorization review"),
  component: ReviewRoute,
});

function ReviewRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading review queue</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading review queue...</div>
        }
      >
        <ReviewPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
